module.exports = __webpack_public_path__ + "static/media/Guardian Industries.aa1afbc0.svg";